/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAndroidPill: {
  name: 'android-pill';
  data: string;
} = {
  name: 'android-pill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.646.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 .093.13A4.49 4.49 0 0 1 8 2.5c.546 0 1.07.097 1.553.275a.5.5 0 0 1 .093-.129l2-2a.5.5 0 0 1 .708.708L10.47 3.238A4.496 4.496 0 0 1 12.5 7v4a4.5 4.5 0 1 1-9 0V7c0-1.573.807-2.958 2.03-3.762L3.646 1.354a.5.5 0 0 1 0-.708ZM11.5 10.5V7a3.5 3.5 0 1 0-7 0v3.5h7Zm-.035 1a3.5 3.5 0 0 1-6.93 0h6.93ZM7 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
